import structureTypes from 'common/constants/structureTypes'
import { OldTextEntityInterface } from 'common/types/entities/OldEntityInterface'
import ServerPage from 'src/shared/types/server-page-interface'
import { migrateText } from './migrateText'

export default function (page: ServerPage): [ServerPage, boolean] {
  let isChanged = false
  try {
    const entities = Object.values(page.content.entities).reduce(
      (prev, entity) => {
        if (entity.type === structureTypes.TEXT) {
          isChanged = true
        }

        return {
          ...prev,
          [entity.id]:
            entity.type === structureTypes.TEXT
              ? migrateText(entity as OldTextEntityInterface)
              : entity,
        }
      },
      {},
    )
    return [
      {
        ...page,
        content: {
          ...page.content,
          entities,
        },
      },
      isChanged,
    ]
  } catch (e) {
    console.log(`--error--`, page, page.id)

    return [page, false]
  }
}
